import React from "react";
import SearchBar from "./SearchBar";

const SearchNavigation = () => {
  return <SearchBar />;
};

export default SearchNavigation;
